import React, { memo, RefObject, useCallback } from 'react';

import Image from 'components/image';
import InstallButton from 'components/install-button';
import ButtonLink from 'components/button-link';
import { TGame } from 'types';
import './styles.scss';

interface IGameHeader {
  game: TGame;
  innerRef: RefObject<HTMLDivElement>;
  parentRef: RefObject<HTMLDivElement>;
}

const GameHeader: React.FC<IGameHeader> = ({ game, innerRef, parentRef }) => {
  const scrollToTop = useCallback(() => {
    if (parentRef.current) {
      parentRef.current.scroll({ top: 0, behavior: 'smooth' });
    }
  }, [parentRef]);

  return (
    <div ref={innerRef} className="game-header">
      <div className="flex flex-1 justify-center">
        <ButtonLink className="flex justify-end" onClick={scrollToTop}>
          <Image src={game.logoURL} />
        </ButtonLink>
      </div>
      <InstallButton gameId={game.id} trackClickURL={game.trackURL.click} />
    </div>
  );
};

export default memo(GameHeader);
